import { Link } from "react-scroll";
import "./css/Navbar.css";

export default function Navbar(){

    const links = {
        offset: -0.5, // fixea el bug de react-scroll en mobile ya que quedaban active 2 btns de la nav
        spy: true,
        smooth: true,
        duration: 600
    }
    
    return (
        <div className="navbar fadeIn">
            <ul>
                <Link to="about" activeClass="active__li-navbar" offset={links.offset} spy={links.spy} smooth={links.smooth} duration={links.duration}>
                    <li>Inicio</li>
                </Link>
                <Link to="skill" activeClass="active__li-navbar" spy={links.spy} smooth={links.smooth} duration={links.duration}>
                    <li>Skills</li>
                </Link>
                <Link to="project" activeClass="active__li-navbar" spy={links.spy} smooth={links.smooth} duration={links.duration}>
                    <li>Proyectos</li>
                </Link>
            </ul>
        </div>
    );
}